export default __webpack_public_path__ + "static/media/watchdog-2.624fd697.png";